import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function RedirectPage() {
    const { shortUrl } = useParams();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [longUrl, setLongUrl] = useState('');

    useEffect(() => {
        const fetchLongUrl = async () => {
            try {
                const response = await axios.get(
                    `https://urlshortener-serverside.onrender.com/api/links/${shortUrl}`, 
                    { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
                );
                setLongUrl(response.data.longUrl);
                setTimeout(() => { window.location.href = response.data.longUrl; }, 2500);
            } catch (err) {
                console.error('Error fetching long URL:', err);
                setError('Failed to retrieve the original URL. The short link may be invalid or expired.');
            } finally {
                setLoading(false);
            }
        };
        fetchLongUrl();
    }, [shortUrl]);

    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
          window._taboola = window._taboola || [];
          _taboola.push({
            mode: 'alternating-thumbnails-a',
            container: 'taboola-below-article-thumbnails',
            placement: 'Below Article Thumbnails',
            target_type: 'mix'
          });
        `;
        document.body.appendChild(script);
    }, []);

    return (
        <div className="container mt-5">
            <div className="card text-center">
                <div className="card-body">
                    {loading ? <p>Loading... Please wait.</p> : error ? <p style={{ color: 'red' }}>{error}</p> : <p>Redirecting to <a href={longUrl} target="_blank" rel="noopener noreferrer">{longUrl}</a>...</p>}
                </div>
                <div id="taboola-below-article-thumbnails"></div>
                <div className="card-body">
                    <p>Safely redirecting...</p>
                </div>
            </div>
        </div>
    );
}

export default RedirectPage;
